import React, {useState} from 'react';
import _ from "lodash";
import {PageLoader} from "../../../../components/Loader";
import Icon from "../../../../components/Icon";
import "./Categories.scss";
import {Button} from "../../../../components/Button";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {CATEGORIES_ROOT_MEDIAS_KEY, fetchCategoriesRootMedia} from "../../../../../api/public-voissa/categories";
import {MEDIA_KEY, MEDIAS_KEY, updateMediaCategories} from "../../../../../api/public-voissa/medias";
import {toastError} from "../../../../../libs/toast";
import {MEDIA} from "../../../../../const/toasts";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';


const Categories = ({
        mediaId = null,
        categoriesMedia = [],
        categoriesHistory = [],
        handleClose = () =>{}
    }) =>{
    const queryClient = useQueryClient();
    const [categoryActive, setCategoryActive] = useState({});
    const [categories, setCategories] = useState(Array.isArray(categoriesMedia) ? categoriesMedia.map(cat => cat._id) : []);
    const [categoriesTmp, setCategoriesTmp] = useState([]);
    const [updateDate, setUpdateDate] = useState(Date.now());

    const {isSuccess : isSuccessCategories ,data : dataCategories} = useQuery(
        [CATEGORIES_ROOT_MEDIAS_KEY],
        ()=> fetchCategoriesRootMedia(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : [],
            select : (data) => data.data || []
        }
    );

    const {
        mutate : mutateCategoriesMedias,
    } = useMutation((data) => updateMediaCategories(mediaId, data),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([MEDIAS_KEY]);
            await queryClient.invalidateQueries([MEDIA_KEY, mediaId]);
        },
        onError: () =>{
            toastError(MEDIA.ERROR.UPDATE);
        }
    });

    function handleCategories(id, parentId){
        let newCategories = categoriesTmp;
        let isPresent = newCategories.includes(id.toString());

        let getParent = _.find(dataCategories, { '_id': parentId._id });

        if(!getParent.isMultipleSelection){
            let idsChildrens = getParent.childrens.map(item => item._id.toString());
            newCategories = newCategories.filter(item => !idsChildrens.includes(item.toString()));
            isPresent = false;
        }
        if(isPresent){
            newCategories = newCategories.filter(item => item.toString() !== id.toString());
        }
        else if(!isPresent){
            newCategories.push(id.toString());
        }
        setCategoriesTmp(newCategories);
        setUpdateDate(Date.now());
    }

    function handleSubmit(){
        let newCategories = categoriesTmp;
        setCategories(newCategories);
        setCategoriesTmp([]);
        setCategoryActive({});
        mutateCategoriesMedias({categoriesIds : newCategories});
    }


    return (
        <div id={"media-categories"}>
            {!isSuccessCategories ? (
                <PageLoader/>
            ) : (
                <div className={"media-categories-list"}>
                    {!categoryActive._id && dataCategories.map(category =>{
                        let isLockedParent = category.childrens.filter(item => categoriesHistory[item._id.toString()] && categoriesHistory[item._id.toString()].isLocked  && categoriesHistory[item._id.toString()].isValided && !category.isMultipleSelection).length ? true : false;
                        let count = category.childrens.filter(subCat=> categories.includes(subCat._id.toString())).length;
                        return (
                            <div
                                key={category._id}
                                className={"media-categories-list-category"}
                                onClick={() => { setCategoriesTmp([...categories]); setCategoryActive({...category, isLockedParent});}}
                            >
                                {count > 0 ? <span className={`media-categories-list-category-badge`}>{!category.isMultipleSelection ? <FontAwesomeIcon icon={faCheck}/> : count }</span> : null}
                                <Icon type={category.slug} />
                                {category.title}
                            </div>
                        )
                    })}
                    {categoryActive._id ? (
                        <div className={"media-categories-list-category-active"} key={updateDate}>
                            <div className={"media-categories-list-category-title"}><Icon type={categoryActive.slug} /> {categoryActive.title}</div>
                            {categoryActive.isLockedParent ? (
                                    <div className="media-categories-list-category-info">
                                        Cette information a été choisie par un modérateur de Voissa. Vous ne pouvez pas la modifier.
                                    </div>)
                                : null}
                            <div className={"media-categories-list-category-childs"}>
                                {categoryActive.childrens.map((subCat, index) => {
                                    let historyTag = categoriesHistory[subCat._id.toString()];
                                    return (
                                        <Button
                                            key={index}
                                            size={"small"}
                                            btnStyle={"grey"}
                                            active={categoriesTmp.includes(subCat._id.toString())}
                                            className={`
                                                    ${categoriesTmp.includes(subCat._id.toString()) ? "category-valided" : ""}
                                                    ${historyTag && historyTag.isLocked && !categoryActive.isLockedParent ? "category-locked" : ""}
                                                    ${categoryActive.isLockedParent ? "category-parent-locked" : ""}
                                                    ${historyTag && historyTag.isValided ? "category-valided" : ""}
                                                    ${historyTag && !historyTag.isValided && historyTag.isLocked ? "category-invalided" : ""}
                                                `}
                                            onClick={() => categoryActive.isLockedParent || (historyTag && !historyTag.isValided && historyTag.isLocked) ? null : handleCategories(subCat._id,subCat.parentId)}
                                            content={subCat.title}/>
                                    )
                                })}
                            </div>
                            <div className={"media-categories-list-category-footer"}>
                                <Button
                                    size={"small"}
                                    btnStyle={"grey"}
                                    className={"btn-cancel"}
                                    onClick={() =>{ setCategoriesTmp([]); setCategoryActive({})}}
                                    content={"Annuler"}
                                />
                                {!categoryActive.isLockedParent ? <Button
                                    btnStyle={"primary-reverse"}
                                    size={"small"}
                                    className={"ml-8"}
                                    onClick={() => handleSubmit()}
                                    content={"Valider"}
                                /> : null}
                            </div>
                        </div>
                    ) : null}
                </div>
            )}
            {!categoryActive._id ? (
                <div className={"media-categories-list-category-footer footer-desktop"}>
                    <Button
                        size={"small"}
                        btnStyle={"grey"}
                        className={"btn-cancel"}
                        onClick={() => handleClose()}
                        content={"Fermer"}
                    />
                </div>
            ) : null}
        </div>
    )
};

export default Categories;